<template>
  <tr>
    <td :style="{ backgroundColor: color}" class="resource-name resource-column operation column-left">
      <b-card :style="{ backgroundColor: color}" class="h-100">
        <div class="d-flex align-items-center">
          <b-card-text :style="{ 'margin-left': '0.75em', 'min-width':'105px', 'padding-top': '6px' }"
                       class="d-flex align-items-center justify-content-between w-100 cursor-pointer"
                       @click="toggleVisibility">
            <div class="tr-title d-flex align-items-center">{{ title }}</div>
            <b-icon-chevron-right v-if="!isVisible" aria-hidden="true" class="cursor-pointer"/>
            <b-icon-chevron-down v-if="isVisible" aria-hidden="true" class="cursor-pointer"/>
          </b-card-text>
        </div>
      </b-card>
    </td>
    <slot></slot>
  </tr>
</template>

<script>
export default {
  props: ['title', 'isVisible', 'color'],
  methods: {
    toggleVisibility() {
      this.$emit('toggle');
    }
  }
}
</script>
<style scoped>
@import '../../assets/css/timeline.css';

.backwhite {
  background-color: #FFFFFF;
}

.tr-title {
  text-align: left;
  font-weight: 500;
  letter-spacing: 0;
  color: #FFFFFF;
  opacity: 1;
}

svg[aria-label="chevron right"],
svg[aria-label="chevron down"] {
  color: #FFFFFF;
}

</style>



// WEBPACK FOOTER //
// src/views/operationPlanning/EventRowComponent.vue